export default {
  filterAlarmsButtonLabel: 'Filtrovať alarmy',
  filterTimeBucketLabel: 'Granularita',
  paretoOccurrences: 'Pareto',
  paretoDuration: 'Pareto',
  table: 'Štatistiky alarmov',
  gantt: 'Časová os',
};
